<script setup lang="ts">
import { computed } from "vue"
import { PhCaretDown, PhCaretUp, PhCaretUpDown } from "@phosphor-icons/vue"

type SortDirection = false | "asc" | "desc"

type SortableColumn = {
  getIsSorted: () => SortDirection
  toggleSorting: (desc?: boolean) => void
}

const props = defineProps<{
  column: SortableColumn
  label: string
}>()

const sortDirection = computed(() => props.column.getIsSorted())
const icon = computed(() => {
  if (sortDirection.value === "asc") {
    return PhCaretUp
  }
  if (sortDirection.value === "desc") {
    return PhCaretDown
  }
  return PhCaretUpDown
})

function toggleSort() {
  props.column.toggleSorting(sortDirection.value === "asc")
}
</script>

<template>
  <UButton
    type="button"
    color="neutral"
    variant="ghost"
    size="xs"
    :trailing-icon="icon"
    :aria-label="`Sort by ${label}`"
    class="dashboard-table-sort vhs-glitch-trigger"
    @click="toggleSort"
  >
    <span class="vhs-glitch-text" :data-vhs-text="label.toUpperCase()">{{ label }}</span>
  </UButton>
</template>
